import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';
import { MdOutlineLock } from 'react-icons/md';
import { useFormikContext } from 'formik';

import { TierTypes } from 'legacy/events/types';

type TierTypeProps = {
  disabled?: boolean;
};

type TierButtonProps = {
  disabled: boolean;
  children: ReactNode;
  onClick: (id: TierTypes) => void;
  id: TierTypes;
  selected: boolean;
};

const TierButton: FC<TierButtonProps> = ({
  disabled,
  children,
  onClick,
  id,
  selected
}) => {
  const onButtonClick = () => onClick(id);

  return (
    <button
      className={classNames(
        'w-full text-center text-base font-semibold rounded-md py-2 cursor-pointer flex align-center justify-center',
        {
          'bg-white': selected
        },
        disabled && 'cursor-not-allowed text-neutral-500'
      )}
      disabled={disabled}
      type="button"
      onClick={onButtonClick}
    >
      {disabled && selected && <MdOutlineLock size={20} className="mr-1" />}
      {children}
    </button>
  );
};

const TierType: FC<TierTypeProps> = ({ disabled = false }) => {
  const { values, setFieldValue } = useFormikContext<any>();

  const onButtonClick = (selected: TierTypes) => {
    setFieldValue('type', selected);
  };

  return (
    <div className="mb-6">
      <div className="w-full p-[6px] bg-gray-200 rounded-lg flex items-center justify-between">
        <TierButton
          disabled={disabled}
          id={TierTypes.Admission}
          selected={values.type === TierTypes.Admission}
          onClick={onButtonClick}
        >
          Admission
        </TierButton>
        <TierButton
          disabled={disabled}
          id={TierTypes.Addon}
          selected={values.type === TierTypes.Addon}
          onClick={onButtonClick}
        >
          Add-on
        </TierButton>
      </div>
      <p className="text-xs text-gray-500 mt-3">
        {values.type === TierTypes.Admission
          ? 'These tickets will grant guests entry to the event.'
          : 'These tickets are for items such as merch, food & drinks, shuttles, etc...'}
      </p>
    </div>
  );
};

export default TierType;
